import { CLASSES_ERROR, CREATE_CLASS_DIVISION, CREATING_CLASS_DIVISION, GETTING_CLASSES, GET_CLASSES, UPDATE_CLASS, UPDATING_CLASS, UPDATE_CLASS_DIVISION, UPDATING_CLASS_DIVISION } from "../types"

const initialState = {
    classes: [],
    loadingClasses: false,
    creatingClassDivision: false,
    createdClassDivision: null,
    updatingClassArm: false,
    updatedClassArm: null,
    classesError: null,
    updatingClass: false,
    updatedClass: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_CLASSES:
        return {
            ...state,
            loadingClasses:action.payload,
            // fetchingMembers:false
        }
        case GET_CLASSES:
        return{
            ...state,
            loadingClasses:false,
            classesError: false,
            classes: action.payload,
        }
        case UPDATING_CLASS:
        return {
            ...state,
            updatingClass:action.payload,
        }
        case UPDATE_CLASS:
        return{
            ...state,
            updatingClass:false,
            classesError: null,
            updatedClass: action.payload,
        }
        case CREATING_CLASS_DIVISION:
        return{
            ...state,
            classesError: null,
            creatingClassDivision: action.payload,
        }
        case CREATE_CLASS_DIVISION:
        return{
            ...state,
            creatingClassDivision:false,
            classesError: null,
            createdClassDivision: action.payload,
        }
         case UPDATING_CLASS_DIVISION:
        return{
            ...state,
            classesError: null,
            updatingClassArm: action.payload,
        }
        case UPDATE_CLASS_DIVISION:
        return{
            ...state,
            updatingClassArm:false,
            classesError: null,
            updatedClassArm: action.payload,
        }
        case CLASSES_ERROR:
        return{
            ...state,
            loadingClasses:false,
            classes: null,
            creatingClassDivision: false,
            updatingClassArm: false,
            updatedClassArm: null,
            classesError: action.payload 
        }
        default: return state
    }

}